import { Api } from './api';
import { HttpService } from '@/services/http';
import type { IHttpClient } from '@/services/http';

/**
 * Default API Base Class (Framework Agnostic)
 * 
 * Use this as the base class for API endpoints that don't require
 * special authentication or configuration.
 */
export abstract class DefaultApi extends Api {
  private _httpService: HttpService;

  protected constructor() {
    super();
    this._httpService = new HttpService();
  }

  protected override get api(): IHttpClient {
    return this._httpService.api;
  }

  /**
   * Create an abort controller for request cancellation
   */
  protected createAbortController(): AbortController {
    return this._httpService.createAbortController();
  }
}
